<div class="wrapper wrapper-content">
  <div class="container-fluid">
    <div class="row">
      <waitLoading *ngIf="!validationresult"></waitLoading>
      <!-- <div class=" alert alert-info col-12" role="alert">
          <i class="fas fa-lg fa-info-circle m-r-lg"></i> {{ 'ProcurementProject.models.selectInfo' | translate }}</div> -->
      <ng-container *ngIf="validationresult">
        <!-- <ul>
          <li *ngFor="let error of validationresult.errors">
            <i class="fa fa-lg fa-exclamation-circle text-danger" aria-hidden="true"
              *ngIf="error.result === 'FATAL' || error.result === 'ERROR'"></i>
            <i class="fa fa-lg fa-exclamation-circle text-warning" aria-hidden="true"
              *ngIf="error.result !== 'FATAL' && error.result !== 'ERROR'"></i>
            {{error.message}}
          </li>
        </ul> -->

        <p-table [value]="validationresult.errors" [responsive]="true" [rows]="20" sortField="date"
          [paginator]="validationresult.errors.length > 20" [pageLinks]="4" [rowsPerPageOptions]="[15, 30, 100]">
          <ng-template pTemplate="header">
            <tr>
              <th [style.width]="'3%'"></th>
              <th [style.width]="'97%'"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-error>
            <tr>
              <td>
                <i class="fa fa-lg fa-exclamation-circle text-danger" aria-hidden="true"
                  *ngIf="error.result === 'FATAL' || error.result === 'ERROR'"></i>
                <i class="fa fa-lg fa-exclamation-circle text-warning" aria-hidden="true"
                  *ngIf="error.result !== 'FATAL' && error.result !== 'ERROR'"></i>
              </td>
              <td>
                {{ error.message || '-'}}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="3" class="text-center">{{ 'General.noData' | translate }}</td>
            </tr>
          </ng-template>
        </p-table>

      </ng-container>
    </div>
  </div>
</div>